import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Container,
  CircularProgress,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';

const ConfirmPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const state = location.state as {
    name: string;
    email: string;
    title: string;
    message: string;
  };

  const handleSubmit = async () => {
    const payload = state;
    const API_ENDPOINT =
      process.env.REACT_APP_API_ENDPOINT || 'http://localhost:3030';

    setLoading(true);

    try {
      const response = await fetch(`${API_ENDPOINT}/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        alert(t('contact.confirm.ok'));
        navigate('/');
      } else {
        alert(t('contact.confirm.error'));
      }
    } catch (error) {
      console.error('There was an error sending the request', error);
    }

    setLoading(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Container
        maxWidth="sm"
        sx={{
          flexGrow: 1,
          paddingBottom: '2rem',
          marginTop: { xs: '2rem', sm: '5rem' },
        }}
      >
        <Box
          mt={4}
          mb={6}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Typography variant="h4" gutterBottom>
            {t('contact.confirm.ttl')}
          </Typography>
          <Typography mb={2}>{t('contact.confirm.note')}</Typography>
          <Box mt={2} width="100%">
            <Typography>
              <strong>{t('contact.form.name')} : </strong>
              {state.name}
            </Typography>
          </Box>
          <Box mt={2} width="100%">
            <Typography>
              <strong>{t('contact.form.email')} : </strong>
              {state.email}
            </Typography>
          </Box>
          <Box mt={2} width="100%">
            <Typography>
              <strong>{t('contact.form.subject')} : </strong>
              {state.title}
            </Typography>
          </Box>
          <Box mt={2} width="100%">
            <Typography>
              <strong>{t('contact.form.content')} :</strong>
              {state.message}
            </Typography>
          </Box>
          <Box textAlign="center" mt={4} width="100%">
            <Button
              variant="outlined"
              color="primary"
              sx={{ textTransform: 'none' }}
              onClick={() => {
                navigate('/contact-form', { state });
              }}
            >
              {t('contact.btn.back')}
            </Button>
            {loading ? <CircularProgress /> : null}
            <Button
              variant="contained"
              color="primary"
              sx={{ marginLeft: '20px', textTransform: 'none' }}
              onClick={handleSubmit}
            >
              {t('contact.btn.submit')}
            </Button>
          </Box>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
};

export default ConfirmPage;
